import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faChargingStation,
  faWifi,
  faWarehouse,
  faSolarPanel,
  faBell,
  faBolt,
  faCamera,
  faLightbulb
} from "@fortawesome/free-solid-svg-icons";

import logo_came from "../img/came.png";
import logo_hager from "../img/hager.png";
import logo_urmet from "../img/urmet.png";
import logo_thermor from "../img/thermor.png";

const iconMap = {
  bolt: faBolt,
  "charging-station": faChargingStation,
  warehouse: faWarehouse,
  "solar-panel": faSolarPanel,
  lightbulb: faLightbulb,
  bell: faBell,
  camera: faCamera,
  wifi: faWifi
};

const partnersMap = {
  came: logo_came,
  thermor: logo_thermor,
  hager: logo_hager,
  urmet: logo_urmet
};

const Expertise = () => {
  const [competences, setCompetences] = useState([]);
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    fetch("/competences")
        .then(res => res.json())
        .then(data => setCompetences(data))
        .catch(err => console.error(err));

    fetch("/partners")
        .then(res => res.json())
        .then(data => setPartners(data))
        .catch(err => console.error(err));
  }, []);

  return (
      <section
          id="competences"
          className="bg-light-background dark:bg-dark-background py-6 h-full"
      >
        <div className="h-2/3">
          <h2 className="text-3xl text-center text-light-text dark:text-dark-text pt-2 pb-6 max-sm:text-xl">
            T.ELEC vous offre son expertise pour :
          </h2>

          <p className="text-center text-light-text dark:text-dark-text max-w-4xl mx-auto px-4 pb-10">
            Électricité générale, bornes IRVE, domotique, motorisation de portail, interphonie, sécurité et solutions solaires à Nancy et alentours.
          </p>

          <div className="flex justify-center flex-wrap items-stretch sm:px-32 max-sm:px-5">
            {competences.map((competence) => (
                <div
                    key={competence.content}
                    className="flex flex-col justify-start items-center w-1/4 max-sm:w-1/2 h-56 py-4"
                >
                  <div className="border-2 rounded-full dark:bg-gray-300 w-10 h-10 p-10 flex justify-center items-center">
                    <FontAwesomeIcon
                        icon={iconMap[competence.icon]}
                        className="w-6 h-6 dark:text-slate-900"
                    />
                  </div>

                  <p className="text-center pt-4 dark:text-dark-text max-sm:text-sm">
                    {competence.content}
                  </p>
                </div>
            ))}
          </div>
        </div>

        <div className="h-1/3">
          <h2 className="text-3xl text-center text-light-text dark:text-dark-text pt-5 pb-5">
            Nos partenaires
          </h2>

          <p className="text-center text-light-text dark:text-dark-text max-w-4xl mx-auto px-4 pb-6">
            Nous travaillons avec des marques reconnues pour garantir des installations fiables et durables.
          </p>

          <div className="flex w-full sm:px-32">
            <div className="flex flex-row max-sm:flex-wrap w-full justify-between pt-5 pb-5">
              {partners.map((partner) => (
                  <div
                      key={partner.title}
                      className="flex flex-col items-center justify-center max-sm:w-1/2 max-sm:mb-5"
                  >
                    <h3 className="font-bold text-light-text dark:text-dark-text pb-3">
                      {partner.title}
                    </h3>
                    <img
                        className="w-24 h-24"
                        src={partnersMap[partner.image]}
                        alt={`Logo ${partner.title}`}
                    />
                  </div>
              ))}
            </div>
          </div>
        </div>
      </section>
  );
};

export default Expertise;